<!--

    TODO:
    1. rewire
    2. Replace with mat-list & (mat-list-item for rx-list-item)

-->
<div *ngIf="!insideVisibleArea" class="rel" style="height: 60px; width: 100%">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    xml:space="preserve"
    style="position: absolute; left: 0; top: 0; width: 100%; height: 100%"
  >
    <g x="50">
      <rect x="15" y="15" rx="3" ry="3" width="28" height="30" fill="#e4eef7" stroke-width="0" />
      <rect x="60" y="15" rx="5" ry="5" width="25%" height="11" fill="#e4eef7" stroke-width="0" />
      <rect x="60" y="35" rx="5" ry="5" width="50%" height="11" fill="#e4eef7" stroke-width="0" />
    </g>
  </svg>
</div>
<div class="toolbar" *ngIf="insideVisibleArea">
  <div class="content">
    <!-- Leading Image or Icon -->
    <rx-icon [name]="icon" *ngIf="icon"></rx-icon>

    <!-- Title & Descriptions  -->
    <!-- TODO: Refactor this. (Single/Double/Tripple line content can be used)  -->

    <div class="content-text">
      <div>
        <div class="top">{{ title }}</div>
        <div class="bottom">{{ description }}</div>
      </div>
    </div>

    <mat-radio-button
      name="radio-btn"
      ngDefaultControl
      [checked]="value"
      [value]="data"
      (change)="onModelChanged($event)"
    >
    </mat-radio-button>
  </div>
</div>
